module.exports = __webpack_public_path__ + "static/assets/4298c99d120ac73dc5783dab2d954fe1.svg";